<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from 'vue'

const animatedElement = ref(null)
const index = ref(1)
const frames = 6

let animationInterval = null

const animate = () => {
  // clear first animation class
  animatedElement.value.classList.remove(`marker__animation--frame-${index.value}`)

  // increment to next frame
  index.value += 1
  if (index.value >= frames) index.value = 0

  // apply next animation class
  animatedElement.value.classList.add(`marker__animation--frame-${index.value}`)
}

onMounted(() => {
  animationInterval = setInterval(animate, 1000)
})

onBeforeUnmount(() => {
  clearInterval(animationInterval)
})
</script>

<template>
  <div data-test-id="animated-food-marker">
    <div class="marker">
      <div
          ref="animatedElement"
          class="marker__animation"
          :class="{ 'marker__animation--frame-0': true }"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@keyframes upDownSine {
  to {
    transform: translateY(-5px);
  }
}

.marker {
  position:         relative;
  width:            18px;
  height:           18px;
  background-image: url("/assets/img/icons/small-arrow-down.svg");
  background-size:  contain;
  background-repeat: no-repeat;

  &__animation {
    position:          absolute;
    top:               -60px;
    left:              -21px;
    width:             60px;
    height:            60px;
    background-size:   36px;
    background-position: center;
    background-repeat: no-repeat;
    animation:         upDownSine 0.8s alternate infinite ease-in-out;
    background-color:  #ffffff;
    border-radius:     50%;
    border:            1px solid var(--color-neutral-primary);

    &--frame-0 {
      background-image: url("/assets/img/AnimatedFoodMarker/taco.png");
    }

    &--frame-1 {
      background-image: url("/assets/img/AnimatedFoodMarker/noodles.png");
    }

    &--frame-2 {
      background-image: url("/assets/img/AnimatedFoodMarker/pizza.png");
    }

    &--frame-3 {
      background-image: url("/assets/img/AnimatedFoodMarker/hot-dog.png");
    }

    &--frame-4 {
      background-image: url("/assets/img/AnimatedFoodMarker/soft-drink.png");
    }

    &--frame-5 {
      background-image: url("/assets/img/AnimatedFoodMarker/fried-chicken.png");
    }
  }
}
</style>
